<template>
  <PrintCajaLayout :header="$t('Extracción de caja')">
    <template #content>
      <div>
        <table style="border: 0; width: 100%">
          <tr>
            <td style="text-align: left; font-weight: bold">{{ $t("Descripcion")}}</td>
            <td style="text-align: right; font-weight: bold">{{ $t("Importe")}}</td>
          </tr>
          <tr>
            <td style="text-align: left">{{ extraccion.descripcion }}</td>
            <td style="text-align: right">{{ extraccion.importe | money }}</td>
          </tr>
        </table>
      </div>
    </template>
    <template #footer>
      <div class="text-left ml-1">
        {{ $t('Fecha:') }} {{extraccion.fecha}} {{extraccion.created|moment('HH:mm')}}<br>
        {{ $t('Empleado:') }} {{ $store.state.auth.user.nombre_completo }}
      </div>
    </template>
  </PrintCajaLayout>
</template>

<script>
import UserDeviceMixin from "@/mixins/UserDeviceMixin";
export default {
  name: "PrintExtraccionCaja",

  data: () => ({
    extraccion: {}
  }),

  mixins: [UserDeviceMixin],

  methods: {
    async get_extraccion() {
      const data = await this.$store.dispatch('caja/get_extraccion', this.$route.params.id)

      this.extraccion = data
    },

    imprimir() {
      setTimeout(() => {
        if (this.centro.is_pass_print && (['mobile', 'tablet'].includes(this.get_device()))) {
          let receiptHTML = '<!DOCTYPE html><html><head><title></title><meta charset="UTF-8"><meta name="viewport" content="width=576"></head><body>';
          receiptHTML += document.getElementById("content_ticket").innerHTML;
          receiptHTML += "</body></html>"
          const receiptB64 = encodeURIComponent(receiptHTML);
          location.href = "starpassprnt://v1/print/nopreview?back=null&html=" + receiptB64
        } else {
          window.print()
        }
      }, 2000)
    },
  },

  mounted() {
    this.get_extraccion()
    this.imprimir()
  },

  components: {
    PrintCajaLayout: () => import('@/components/impresiones/PrintCajaLayout')
  }
}
</script>

<style scoped>

</style>
